import React, { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const VIDEO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_instant-guidance-1/artifacts/38a630bd52f71203_ElevenLabs_video_heygen-avatar-4_2026-10-22T23_04_45.mp4";

export const WelcomeVideo = () => {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleSound = () => {
    const v = ref.current;
    if (muted) v.currentTime = 0;
    v.muted = !muted;
    v.play().catch(() => {});
    setMuted(!muted);
  };

  return (
    <div className="relative mx-auto max-w-[250px] sm:max-w-[340px]" data-testid="welcome-video">
      <div className="absolute -inset-3 sm:-inset-5 bg-[#F2CC8F]/30 rounded-[3rem] rotate-3" />
      <div className="relative rounded-[2.5rem] overflow-hidden border border-[#2A3B32]/10 shadow-[0_20px_60px_rgba(42,59,50,0.12)] bg-[#2A3B32] aspect-[9/16]">
        <video
          ref={ref}
          src={VIDEO_URL}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="https://customer-assets-0z36b82j.emergentagent.net/job_instant-guidance-1/artifacts/69449ecd5a98f9c2_FB_IMG_1792584084246.jpg"
          onClick={toggleSound}
          className="w-full h-full object-cover cursor-pointer"
          data-testid="welcome-video-player"
        />
        <button
          onClick={toggleSound}
          data-testid="welcome-video-sound-toggle"
          className="absolute bottom-3 left-3 sm:bottom-4 sm:left-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#FDFBF7]/90 backdrop-blur text-sm text-[#1C221D] hover:bg-[#FDFBF7] transition-colors duration-200"
        >
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          {muted ? "Tap for sound" : "Mute"}
        </button>
      </div>
      <div className="relative mt-4 sm:mt-6 text-center">
        <div className="font-serif-display text-2xl text-[#1C221D]">India Sadie</div>
        <div className="eyebrow text-[#5C6A61] mt-1">certified life coach · online</div>
      </div>
    </div>
  );
};
